import { Typography } from '@telavita-core/react-design-kit'
import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'
import React from 'react'
import { handleProfileCode } from 'utils'

import * as S from './styles' 

import { ReactComponent as ChevronRight } from 'static/svg/chevron-right.svg'


interface UpdateDefaultPlanModalProps {
  professionalFullName: string
  professionalDoc: string
  professionalType: string
  professionalImage: string
  patientPlans: Array<{
    planGroupName: string
    planName: string
    isEnable: boolean
    planCode: string
  }>
  onSelectPlan: (planCode: string) => void
  onClose: () => void
}

interface PlanButtonProps {
  planGroupName: string
  planName: string
  isEnable: boolean
  planCode: string
  onClick: (planCode: string) => void
}

const PlanButton = ({
  isEnable,
  planGroupName,
  planName,
  planCode,
  onClick,
}: PlanButtonProps) => {
  return (
    <S.PlanButton disabled={!isEnable} onClick={() => onClick(planCode)}>
      <S.PlanInfo>
        <Typography variant='content2' inheritColor>
          {planGroupName}
        </Typography>
        <Typography variant='content3' inlineStyles={{ color: '#898989' }}>
          {planName}
        </Typography>
      </S.PlanInfo>
      <S.PlanButtonIconWrapper>
        <Typography variant='content3' inlineStyles={{
          color: isEnable ? '#56C730' : '#FC4949',
          marginRight: isEnable ? 0 : 29
        }}>
          {isEnable ? 'ATENDE' : 'NÃO ATENDE'}
        </Typography>
        {isEnable && <ChevronRight />}
      </S.PlanButtonIconWrapper>
    </S.PlanButton>
  )
}

const UpdateDefaultPlanModal = ({
  professionalFullName,
  professionalDoc,
  professionalType,
  professionalImage,
  patientPlans,
  onSelectPlan,
  onClose
}: UpdateDefaultPlanModalProps): JSX.Element => {

  const onSelect = (planCode) => {
    onSelectPlan(planCode)
  }

  return (
    <ModalGeneric
      customClassName='UpdateDefaultPlanModal'
      modalTitle={null}
      onCloseModal={onClose}
    >
      <S.Container>
        <S.ProfessionalImage 
          style={{
            'background': `url(${professionalImage})`,
            'backgroundSize': 'cover',
            'backgroundPosition': 'center center'
          }}
        />
        <Typography variant='header4' weight='bold' center>
          Escolha como quer agendar com {professionalFullName}
        </Typography>
        <Typography variant='content2'>
          {handleProfileCode(professionalType)}{professionalDoc}
        </Typography>
        <S.PlansButtonWrapper>
          {patientPlans.map(pPlan => (
            <PlanButton 
              planGroupName={pPlan.planGroupName}
              planName={pPlan.planName}
              isEnable={pPlan.isEnable}
              planCode={pPlan.planCode}
              onClick={onSelect}
            />
          ))}
        </S.PlansButtonWrapper>
      </S.Container>
    </ModalGeneric>
  )
}

export default UpdateDefaultPlanModal